import { GeneralOption } from './UtilComponents';
import {
  words,
} from './globalState';
import { syncHttpRequest2 } from './utils';

// HANDLE CLICK DECK NUMBER
function handleClickDeckNumber(state, dispatch, addressMain) {
  let options = [];

  for (let i = 1; i <= 10; i++) {
    let deckName;

    if (state.deckSet[addressMain].decks[i] !== undefined) {
      deckName = state.deckSet[addressMain].decks[i].deckName;
    }
    else {
      deckName = '';
    }

    options.push(
      <GeneralOption
        record={{
          deckNo: {
            value: i,
            face: i,
            style: 'selectDeckDeckNo'
          },
          deckName: {
            face: deckName,
            style: 'selectDeckDeckName'
          },
        }}
        recordKey='deckNo'
        sortedKeys={ ['deckNo', 'deckName'] }
        stateKeys={ ['deckSet', addressMain, 'currentDeckNo'] } layer={ 0 }
        onSelect={ selectedDeckNo => {
          const updates = [];

          if (state.deckSet[addressMain].decks[selectedDeckNo] === undefined || state.deckSet[addressMain].decks[selectedDeckNo] === null) {
            updates.push({
              keys: ['deckSet', addressMain, 'decks', selectedDeckNo],
              value: {
                deckName: `deck${selectedDeckNo}`,
                cards: [],
              },
            });
          }

          updates.push({
            keys: ['deckSet', addressMain, 'currentDeckNo'],
            value: selectedDeckNo,
          });

          dispatch({ type: 'setStateMultiLayersAtomic', updates: updates });
        } }
      />
    );
  }

  const popup = {
    type: 'generalList',
    body: {
      'title': 'deck No',
      'options': options,
    },
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
}

// HANDLE CLICK SAVE DECK
async function handleClickSaveDeck(state, dispatch) {
  let request = {};
  let messages = {};

  // state固定
  const stateFixed = {
    addressMain: state.active.addressMain,
    sessionId: state.session[state.active.addressMain].sessionId,
    deckSet: state.deckSet[state.active.addressMain],
  };

  request.body = JSON.stringify({
    body: {
      addressMain: stateFixed.addressMain,
      sessionId: stateFixed.sessionId,
      deckSet: stateFixed.deckSet,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/save_deck';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
    "invalid session.": words.pleaseLogin[state.language],
    "success": words.success[state.language],
  };

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  if ( response.status === 'rejected' ) {
    return {
      status: 'rejected',
    };
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['deckSet', stateFixed.addressMain, 'status'], value: 'saved' });

  return {
    status: 'fulfilled',
  };
}

export {
  handleClickDeckNumber,
  handleClickSaveDeck,
}
